import { render } from "./EmpDashboardPage.vue?vue&type=template&id=a38ec526"
import script from "./EmpDashboardPage.vue?vue&type=script&lang=js"
export * from "./EmpDashboardPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__